/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Affix, Code, Paper, Switch, rem } from '@mantine/core';

import { envIs } from '@fai/friendli-suite/shared/environments/conditionals';
import { useHideFromReleaseStore } from '@fai/friendli-suite/shared/environments/hide-from-release';
import { CodeVariants } from '@fai/ui/components/typography/variants';

export function HideWrapperAffix() {
  const { isWrapperVisible, toggleIsWrapperVisible } = useHideFromReleaseStore();

  if (envIs.PRODUCTION || envIs.STAGING) return null;

  return (
    <Affix position={{ bottom: 20, left: 160 }}>
      <Paper
        bg={isWrapperVisible ? '#0b8d5a' : '#484848'}
        c="white"
        display="flex"
        pl={rem(4)}
        pr={rem(12)}
        py={rem(3)}
        shadow="xs"
        style={{ alignItems: 'center', gap: rem(8) }}
      >
        <Code variant={CodeVariants.Md}>hideFromWrapper</Code>

        <Switch
          checked={isWrapperVisible}
          color="#e4cf38"
          size="xs"
          onChange={toggleIsWrapperVisible}
        />
      </Paper>
    </Affix>
  );
}
